import { createAblyRestClient } from '@mentimeter/realtime';
import { ablyConfig } from './ablyConfig';

export const ablyRestClient = createAblyRestClient(ablyConfig);
